import { render, staticRenderFns } from "./ModalSendPurchaseOrder.vue?vue&type=template&id=573d483c&lang=pug&"
import script from "./ModalSendPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./ModalSendPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports